import {Box, Button, Stack} from '@primer/react-brand'

import type {Link} from '../../../types'

interface PricingSectionCtasProps {
  ctas: Link[]
}

export function PricingSectionCtas({ctas}: PricingSectionCtasProps) {
  return (
    <Box marginBlockStart={32}>
      <Stack direction="horizontal" justifyContent="center" gap="normal">
        {ctas.map(cta => (
          <Button key={cta.sys.id} as="a" href={cta.fields.href} variant="secondary" size="medium">
            {cta.fields.text}
          </Button>
        ))}
      </Stack>
    </Box>
  )
}
